import React from 'react'
import ReactDOM from 'react-dom/client'
import App from 'app/App'
import { IonApp } from '@ionic/react'
import 'style.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <IonApp>
    <App />
  </IonApp>
)
